namespace $.$$ {

	export class $shm_hitalama_map_history_view extends $.$shm_hitalama_map_history_view {

		@ $mol_mem
		events_page() {
			const history = this.map().history_maybe()
			if( !history ) return { count: 0, events: [] }
			// The target index provides newest entries first. Its compact summaries
			// are enough for this list; a full event payload is read only for an
			// explicitly expanded row or an undo/redo operation.
			return history.entries_page_retained_for(
				[ '__all__' ],
				this.events_limit( this.map().link().str ),
			)
		}

		events() {
			return this.events_page().events
		}

		@ $mol_mem_key
		events_limit( map: string, next = $shm_hitalama_map_history.storage_recent_size ) {
			return next
		}

		earlier_enabled() {
			const page = this.events_page()
			return page.events.length < page.count
		}

		@ $mol_action
		earlier_load( event?: Event | null ) {
			if( event ) {
				const id = this.map().link().str
				this.events_limit( id, this.events_limit( id ) + $shm_hitalama_map_history.storage_recent_size )
			}
			return event ?? null
		}

		@ $mol_mem
		event_index() {
			return new Map( this.events().map( event => [ event.link().str, event ] ) )
		}

		event_ids() {
			return this.events().map( event => event.link().str )
		}

		history_event( id: string ) {
			return this.event_index().get( id ) ?? null
		}

		history_event_full( id: string ) {
			return this.history_event( id )?.full() ?? null
		}

		event_rows() {
			return this.event_ids().map( id => this.Event( id ) )
		}

		event_content( id: string ) {
			return [
				this.Event_summary( id ),
				... this.expanded( id ) ? [ this.Event_details( id ) ] : [],
			]
		}

		event_title( id: string ) {
			const data = this.history_event( id )?.data()
			if( !data ) return 'Неизвестное изменение'
			const prefix = data.source === 'undo' ? 'Отменено: '
				: data.source === 'redo' ? 'Повторено: '
				: ''
			return `${ prefix }${ data.title }`
		}

		event_meta( id: string ) {
			const event = this.history_event( id )
			if( !event ) return ''
			const date = new Intl.DateTimeFormat( 'ru-RU', {
				day: '2-digit', month: '2-digit', year: 'numeric',
			} ).format( event.time() )
			const time = new Intl.DateTimeFormat( 'ru-RU', {
				hour: '2-digit', minute: '2-digit',
			} ).format( event.time() )
			const author_id = event.author()
			const author = this.$.$shm_hitalama_profile.user_name( author_id ) || author_id || event.peer()
			return `${ date } ${ time } · ${ author }`
		}

		event_details( id: string ) {
			// A summary contains only a bounded preview. Fetch the complete event
			// only after the person explicitly opens this row.
			const changes = this.history_event_full( id )?.data()?.changes ?? []
			const labels: Record< string, string > = {
				widget_set: 'Изменение виджета', widget_add: 'Добавление виджета', widget_remove: 'Удаление виджета',
				widgets_order: 'Порядок виджетов',
				cell_set: 'Изменение ячейки', field_set: 'Изменение поля', field_add: 'Добавление поля', field_remove: 'Удаление поля',
				row_add: 'Добавление записи', rows_add: 'Добавление записей',
				row_remove: 'Удаление записи', rows_remove: 'Удаление записей', rows_update: 'Изменение записей',
			}
			return changes.map( change => {
				const field = change.meta?.field_title ? ` · ${ change.meta.field_title }` : ''
				return `${ labels[ change.type ] ?? 'Изменение' }${ field }: ${ this.value_text( change.before ) } → ${ this.value_text( change.after ) }`
			} ).join( '\n' ) || 'Без изменений данных'
		}

		value_text( value: any ): string {
			if( value?.constructor === Object && Object.keys( value ).length === 1 && 'text' in value ) {
				return this.value_text( value.text )
			}
			if( $shm_hitalama_map_history_text_file_is( value ) ) {
				return `${ value.preview }${ value.size > value.preview.length ? '…' : '' } (${ value.size } байт)`
			}
			if( typeof value === 'string' ) return value || '∅'
			if( value === null || value === undefined ) return '∅'
			return JSON.stringify( value )
		}

		event_toggle( id: string, event?: Event | null ) {
			if( event ) this.expanded( id, !this.expanded( id ) )
			return event ?? null
		}

		@ $mol_mem
		undo_enabled() {
			const candidate = this.map().history_maybe()?.undo_candidate()
			return Boolean( candidate?.data_ready() )
		}

		@ $mol_mem
		redo_enabled() {
			const candidate = this.map().history_maybe()?.redo_candidate()
			return Boolean( candidate?.[1].data_ready() )
		}

		undo( event?: Event | null ) {
			if( event ) this.map().history_undo()
			return event ?? null
		}

		redo( event?: Event | null ) {
			if( event ) this.map().history_redo()
			return event ?? null
		}

	}

}
